import { Record, Map } from 'immutable'

const IntegrationRecord = Record(
  {
    id: '',
    unfurlPatterns: [],
    activityTargets: Map(),
    hasAuthenticationForUser: false,
    hasIntegrationActivitySupport: false,
    activitySettingsForChannel: Map(),
    application: Map(),
  },
  'Integration'
)

export default IntegrationRecord
